import { render, staticRenderFns } from "./BasePaneTray.vue?vue&type=template&id=d75efbb2&scoped=true&"
import script from "./BasePaneTray.vue?vue&type=script&lang=js&"
export * from "./BasePaneTray.vue?vue&type=script&lang=js&"
import style0 from "./BasePaneTray.vue?vue&type=style&index=0&id=d75efbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75efbb2",
  null
  
)

export default component.exports